import React from "react";
import useBreakpoint from "../../hooks/useBreakpoints";
import Gradient from "../Gradient";
import Avatar from "../../assets/images/avatar.svg";
import PaperTip from "../../assets/images/tip-paper.png";

const WhoWeAreSection = ({ data, anchorId }) => {
  const { isLaptop } = useBreakpoint();

  if (!data) return null;

  const { title, description, subTitle, keyPoint } = data;

  return (
    <section className="section who-section flex-wrapper" id={anchorId}>
      <div className="flex-container section-container">
        <div className="left-block">
          <img className="avatar" src={Avatar} alt="avatar" />
          <div className="info-tip">
            <img className="info-tip__img" src={PaperTip} alt="" role="presentation" />
            <p>{keyPoint}</p>
          </div>
        </div>
        <div className="right-block">
          <span className="subTitle">{subTitle}</span>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      </div>
      <Gradient
        imageName="gradient5"
        className="gradientLeft"
        right="initial"
        top={isLaptop ? "-150px" : "-250px"}
        left="-135px"
        width="850px"
        height="700px"
      />
    </section>
  );
};

export default WhoWeAreSection;
